"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _withSizePresets = _interopRequireDefault(require("./withSizePresets"));
/* eslint-disable max-len */

var ChevronDown = function ChevronDown(props) {
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, (0, _extends2["default"])({
    viewBox: "0 0 19 12"
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Chevron Down"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Summary-Sidebar",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "chevron_up",
    fill: "#F96303",
    transform: "translate(9.500000, 5.996582) scale(1, -1) translate(-9.500000, -5.996582) ",
    points: "16.1445312 11.6875 9.5 4.69433594 2.75292969 11.6875 0.743164062 9.49316406 9.5 0.305664062 18.2568359 9.49316406"
  })));
};
var _default = (0, _withSizePresets["default"])(19, 12)(ChevronDown);
exports["default"] = _default;
//# sourceMappingURL=ChevronDown.js.map